let bootstrapPromise: Promise<unknown> | null = null;

/** Ensures app bootstrap runs at most once per page session (survives StrictMode remounts). */
export function runAppBootstrapOnce<T>(run: () => Promise<T>): Promise<T> {
  if (!bootstrapPromise) {
    bootstrapPromise = run();
  }
  return bootstrapPromise as Promise<T>;
}

/** Test helper — allow a fresh bootstrap in the next Vitest case. */
export function resetAppBootstrapCoordinatorForTests(): void {
  bootstrapPromise = null;
}
